import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//             Отправить запрос на получение обновлений на странице
//------------------------------------------------------------------------------
export const checkUpdatedData = async (unix) => {
  const url = `${backendUrl}/api/alpha/check-update/?datetime=${unix}`;
  const options = {
    method: 'GET',
    headers: {'Content-Type': 'application/json'},
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении иформации об обновлениях на странице: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения информации об обновлениях на странице:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
